module.exports = "<div>\n  <div style=\"display: block\">\n    <canvas #chartElecCons></canvas>\n  </div>\n</div>"